import { For } from "solid-js";
import { Text, View, hexColor } from "@lightningtv/solid";
import { t } from "../../../translations/configuration";
import { clientBranding } from "../../../config/clientConfig";

const textStyle = {
  fontSize: 20,
  color: hexColor("#ffffff"),
  fontWeight: 400,
  lineHeight: 32,
  width: 1300,
  contain: "width" as const,
};

const headingStyle = {
  fontSize: 24,
  color: hexColor("#ffffff"),
  fontWeight: "bold" as const,
  lineHeight: 32,
  width: 1300,
  contain: "width" as const,
};

// Non-evomedia clients (e.g. Innplay) show this same policy text, just with
// the "Evomedia" brand word swapped out. Only the capitalized word is
// touched, so support/developer email addresses (which use the lowercase
// "evomedia.pt" / "evomedia..." domain) are left alone.
const rebrand = (text: string, isEvomedia: boolean) =>
  isEvomedia ? text : text.replace(/Evomedia/g, "Innplay");

const buildEvomediaSections = (isEvomedia: boolean): { title: string; body: string[] }[] => [
  {
    title: rebrand(t("evomediaSection1Title"), isEvomedia),
    body: [
      rebrand(t("evomediaSection1Body1"), isEvomedia),
      rebrand(t("evomediaSection1Body2"), isEvomedia),
    ],
  },
  {
    title: rebrand(t("evomediaSection2Title"), isEvomedia),
    body: [rebrand(t("evomediaSection2Body1"), isEvomedia)],
  },
  {
    title: rebrand(t("evomediaSection3Title"), isEvomedia),
    body: [rebrand(t("evomediaSection3Body1"), isEvomedia)],
  },
  {
    title: rebrand(t("evomediaSection4Title"), isEvomedia),
    body: [rebrand(t("evomediaSection4Body1"), isEvomedia)],
  },
  {
    title: rebrand(t("evomediaSection5Title"), isEvomedia),
    body: [
      rebrand(t("evomediaSection5Body1"), isEvomedia),
      rebrand(t("evomediaSection5Body2"), isEvomedia),
    ],
  },
];

// Both variants below are a flex column of Text nodes: each paragraph is
// placed after the one before it, sized by its own actual rendered height.
// That replaces the old CHARS_PER_LINE/estimateLines math, which guessed
// each paragraph's height from its character count and broke whenever a
// translation wrapped to more or fewer lines than the guess.

const EvomediaPrivacyPolicy = (props: any) => {
  const isEvomedia = () => clientBranding().clientId === "evomedia";

  return (
    <View ref={props.ref} x={550} y={50} height={2000} width={2000} clipping>
      <View style={{ display: "flex", flexDirection: "column", gap: 12, width: 1300 }}>
        <Text style={{ fontSize: 34, fontWeight: "bold", color: hexColor("#ffffff") }}>
          {rebrand(t("evomediaTitle"), isEvomedia())}
        </Text>
        <Text style={{ fontSize: 23, color: hexColor("#B9B9BE") }}>
          {t("evomediaSubtitle")}
        </Text>

        <For each={buildEvomediaSections(isEvomedia())}>
          {(section) => (
            <View style={{ display: "flex", flexDirection: "column", gap: 4, width: 1300 }}>
              <Text style={headingStyle}>{section.title}</Text>
              <For each={section.body}>
                {(paragraph) => <Text style={textStyle}>{paragraph}</Text>}
              </For>
            </View>
          )}
        </For>
      </View>
    </View>
  );
};

const DefaultPrivacyPolicy = (props: any) => {
  const terms = [
    t("one"), t("two"), t("three"), t("four"), t("five"), t("six"),
  ];

  return (
    <View ref={props.ref} x={550} y={80} height={2000} width={2000} clipping>
      <View style={{ display: "flex", flexDirection: "column", gap: 12, width: 1300 }}>
        <Text style={{ fontSize: 34, fontWeight: "bold", color: hexColor("#ffffff") }}>
          {t("orbixUserAgreement")}
        </Text>
        <Text style={{ fontSize: 23, color: hexColor("#B9B9BE") }}>
          {t("beforeyouProcc")}
        </Text>

        <For each={terms}>
          {(term) => <Text style={textStyle}>{term}</Text>}
        </For>
      </View>
    </View>
  );
};

const PrivacyPolicy = (props: any) => {
  console.log("client", clientBranding().clientId);

  return clientBranding().clientId === "evomedia" ? (
    <EvomediaPrivacyPolicy {...props} />
  ) : (
    <DefaultPrivacyPolicy {...props} />
  );
};

export default PrivacyPolicy;
